import { TableCard } from '../../../../components'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { FaturaProfissionalAtendimentosListHeader } from './components/header/FaturaProfissionalAtendimentosListHeader'
import { FaturaProfissionalResumo } from './components/header/FaturaProfissionalResumo'
import { FaturaProfissionalAtendimentosTable } from './table/FaturaProfissionalAtendimentosTable'

const FaturaProfissionalAtendimentosList = () => {
  return (
    <>
      <FaturaProfissionalResumo />
      <TableCard>
        <FaturaProfissionalAtendimentosListHeader />
        <FaturaProfissionalAtendimentosTable />
      </TableCard>
    </>
  )
}

export const FaturaProfissionalAtendimentosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <FaturaProfissionalAtendimentosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
